/**
 * 文件的下载逻辑
 * @author huangshuo
 * time 2019-12-24
 */

import * as Util from 'js/util/util.js'
import { mulDownload } from './multi.js'
import { singleDownload, editCheck } from './single.js'
import { sendLogBuryingPointMethods } from '../privateApi/private-apis'
/**
 * 预览逻辑文件下载
 * @param data 下载的文件(单文件，或者文件包) {isDir:'true/false', 'content':'[{'metaData'},{},...]'}
 */
const bsFileDownLoad = function (data) {
  // 验证文件是否还存在,不存在组合的url都是失效的???
  // (基础)下载逻辑部分
  if (data.isDir || data.content.length > 1) {
    // 文件夹下载,多文件下载
    mulDownload(data.content, false, data.storageUrl, (status, res) => {
      // 异常处理
      if (!status) {
        messageHandle(res, 'mul', data.content)
      }
    })
  } else {
    // 单文件下载
    const { path_type: pathType, nsid, path } = data.content[0]
    let fileName = ''
    const arr = path.split('/')
    fileName = arr[arr.length - 1]
    if (!Util.isClient()) {
      sendLogBuryingPointMethods({
        category: 0, 
        action: 2, 
        pathType, 
        nsid, 
        entityStr1: fileName, 
        entityStr2: path.substring(0, path.lastIndexOf('/')) === '' ? '/' : path.substring(0, path.lastIndexOf('/')),
      }) 
    }
    singleDownload(data.content, false, (status, res) => {
      if (!status) {
        messageHandle(res, 'sin', data.content)
      }
    })
  }
}


/**
 * @param metaData
 */
const fileEditCheck = function (metaData, callback) {
  // 本地编辑
  editCheck(metaData, (status, res) => {
    if (status) {
      if (typeof callback === 'function') callback(metaData)
    } else {
      // 异常提示
      messageHandle(res, 'edit', metaData, callback)
    }
  })
}


/**
 * 下载文件的异常处理
 * @param err 异常返回值
 * @param isMul 是否为多文件
 * @param data 原处理文件
 * @param callback 回调函数
 */
function messageHandle(err, isMul, data, callback) {
  if (err.response) {
    // 获取必要的参数
    const error = err.response.data
    let warnType = ''
    if (error.extra_info) {
      warnType = JSON.parse(error.extra_info).warnType
    }

    // 处理异常逻辑
    if (warnType === 'toast' && (isMul === 'sin' || isMul === 'edit')) {
      // 弹窗提示警告信息
      $toast.simpleShow(error.message, 'warn')
    } else if (warnType === 'windows') {
      // 提示信息(确认并回调下载)
      $confirm.show({
        value: true,
        isShow: true,
        onlyOne: false,
        title: '提示',
        content: error.message,
        sure() {
          if (isMul == 'mul') {
            mulDownload(data, true)
            $confirm.hide()
          } else if (isMul == 'sin') {
            singleDownload(data, true)
            $confirm.hide()
          } else if (isMul == 'edit') {
            if (typeof callback === 'function') callback(data)
            $confirm.hide()
          }
        },
      })
    } else {
      // 弹窗提示错误信息
      if (error.message) {
        $toast.simpleShow(error.message, 'error')
      }
    }
  }
}

// 导出函数
export { bsFileDownLoad, fileEditCheck }
